import Timeline from './Timeline';

export { TimelineProps } from './Timeline';
export { TimeLineItemProps } from './TimelineItem';

export default Timeline;



// WEBPACK FOOTER //
// ./components/timeline/index.tsx